(function (angular) {
    'use strict';

    angular.module("dentist").directive('businesscardTooltipWrapper', ['$timeout', function($timeout) {
    return {
        link: function($scope, element, attrs) {
        	$timeout(function () { // We might need this timeout to be sure its run after DOM render.
        	    element.tooltip({ placement: "top" });
            }, 0, false);
        },
    };
}]);

})(window.angular);
